import { useLayoutEffect } from 'react';
import kocLogo from '../../assets/koc-logo-footer.png';
import kocAilemlogo from '../../assets/images/koc-ailem-logo.png';

const SuccessPage = () => {

  useLayoutEffect(() => {
    document.body.classList.add('join-form-success');
  }, [])

  return (
    <div className='join-form-success-page'>
      <section>
        <img src={kocAilemlogo} alt="KoçAilem logo" className='header-logo' />
        <h3>Teşekkürler!</h3>
        <p>KoçAilem Programı Katılım Formu onayınız başarı ile kaydedilmiş olup bilgileriniz güncellenmiştir.</p>
        <img src={kocLogo} alt="İçinde Koç var logo" className='footer-logo' />
      </section>
    </div>
  )
}

export default SuccessPage;